import React from 'react'
import PropTypes from 'prop-types'
import Rating from 'react-rating'
import moment from 'moment'

import Styles from './index.scss'
import FilterBox from './FilterBox'

const TabRatingReview = props => (
  <section className={`section-tab ${Styles['section-rating']}`}>
    <div className={`${Styles['review-container']}`}>
      <h3 className={`${Styles['section-title']}`}>
        Rating & Review
      </h3>
      <FilterBox />
      <div className={Styles['feedback-content']}>
        <div className={Styles['feedback-item-container']}>
          <div className={`${Styles['title-feedback']}`}>Client Feedback</div>
        </div>
        <div className={Styles['feedback-item-container']}>
          <div className={`${Styles['title-feedback']}`}>Creator Feedback</div>
        </div>
      </div>
      {props.clientReview.map((review, index) => (
        <div className={Styles['feedback-content']}>
          <div className={Styles['feedback-item-container']}>
            <div className="item-container">
              <div className={`${Styles['feedback-item']}`} key={review.id}>
                <div className={`${Styles['image-user']}`} style={{ backgroundImage: `url("${review.reviewedBy.logo}")` }} />
                <div className={`${Styles.item}`}>
                  <span className={`${Styles['profile-name']}`}>{review.reviewedBy.name}</span>
                  <div className={Styles['rating-container']}>
                    <span className={Styles['rating-number']}>{`${review.rating}`}</span>
                    <Rating
                      initialRating={review.rating}
                      emptySymbol={<i className={`material-icons md-36 ${Styles.rating}`}>star_border</i>}
                      fullSymbol={<i className={`material-icons md-18 ${Styles.rating}`}>star</i>}
                      readonly
                    />
                    <span className={Styles['created-date']}> . {moment(review.updatedAt).format('DD MMMM YYYY')}</span>
                  </div>
                  {review.testimonial ?
                    <div className={`${Styles['text-feedback']}`}>{review.testimonial}</div>
                    : <span className={Styles['skipped-message']}>{review.isAutomated ? 'Automatic Feedback' : 'Skipped'}</span>
                  }
                  <div>
                    <div className={`${Styles['reply-feedback']}`}>
                      <div className={`${Styles['image-user']}`} style={{ backgroundImage: `url("${review.reviewedBy.logo}")` }} />
                      <div className={`${Styles.item}`}>
                        <span>{review.reviewedBy.name}</span>
                        <span className={Styles['private-feedback-container']}>
                          <i className={`material-icons ${Styles['icon-eye']}`}>visibility_off</i>
                          Private Feedback
                        </span>
                        {review.feedback ?
                          <div className={`${Styles['text-feedback']}`}>{review.feedback}</div>
                          : <span className={Styles['skipped-message']}>{review.isAutomated ? 'Automatic Feedback' : 'Skipped'}</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={Styles['feedback-item-container']}>
            <div className="item-container">
              <div className={`${Styles['feedback-item']}`} key={props.creatorReview[index].id}>
                <div className={`${Styles['image-user']}`} style={{ backgroundImage: `url("${props.creatorReview[index].reviewedBy.logo}")` }} />
                <div className={`${Styles.item}`}>
                  <span className={`${Styles['profile-name']}`}>{props.creatorReview[index].reviewedBy.name}</span>
                  <div className={Styles['rating-container']}>
                    <span className={Styles['rating-number']}>{`${props.creatorReview[index].rating}`}</span>
                    <Rating
                      initialRating={props.creatorReview[index].rating}
                      emptySymbol={<i className={`material-icons md-36 ${Styles.rating}`}>star_border</i>}
                      fullSymbol={<i className={`material-icons md-18 ${Styles.rating}`}>star</i>}
                      readonly
                    />
                    <span className={Styles['created-date']}> . {moment(props.creatorReview[index].updatedAt).format('DD MMMM YYYY')}</span>
                  </div>
                  {props.creatorReview[index].testimonial ?
                    <div className={`${Styles['text-feedback']}`}>{props.creatorReview[index].testimonial}</div>
                    : <span className={Styles['skipped-message']}>{props.creatorReview[index].isAutomated ? 'Automatic Feedback' : 'Skipped'}</span>
                  }
                  <div>
                    <div className={`${Styles['reply-feedback']}`}>
                      <div className={`${Styles['image-user']}`} style={{ backgroundImage: `url("${props.creatorReview[index].reviewedBy.logo}")` }} />
                      <div className={`${Styles.item}`}>
                        <span>{props.creatorReview[index].reviewedBy.name}</span>
                        <span className={Styles['private-feedback-container']}>
                          <i className={`material-icons ${Styles['icon-eye']}`}>visibility_off</i>
                          Private Feedback
                        </span>
                        {props.creatorReview[index].feedback ?
                          <div className={`${Styles['text-feedback']}`}>{props.creatorReview[index].feedback}</div>
                          : <span className={Styles['skipped-message']}>{props.creatorReview[index].isAutomated ? 'Automatic Feedback' : 'Skipped'}</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
)

TabRatingReview.propTypes = {
  creatorReview: PropTypes.arrayOf(PropTypes.object).isRequired,
  clientReview: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default TabRatingReview
